import { createFileRoute } from "@tanstack/react-router";

import AddAccountPre from "@/features/onboarding/AddAccountPre";
import BasicLayout from "@/layouts/Basic";

export const Route = createFileRoute("/_auth-basic/add-account-pre")({
  component: () => (
    <BasicLayout>
      <AddAccountPre />
    </BasicLayout>
  ),
});
